import { paramsToQuery } from '@/base/MaUtils.js'
import { makeRequest } from '@/base/MaRequestPooler.js'

export function deleteStore({ storeAccountId }) {
  return makeRequest(`/account/store-account/${storeAccountId}`, {
    method: 'DELETE',
  })
}

/**
 * Returns a promise for fetching list of connected store accounts
 */
export function getStoreAccountList() {
  return makeRequest(`/account/store-account`)
}

export function getAvailableGooglePlayRootAccount() {
  return makeRequest(`/account/store-account/play/available-root-account`)
}

export function googleSendVerificationEmail(email) {
  return makeRequest(`/account/store-account/play?email=${encodeURIComponent(email)}`, {
    method: 'POST',
  })
}

export function googleVerifyEmail(code) {
  return makeRequest(`/account/store-account/play/verify?code=${code}`, {
    method: 'POST',
  })
}

export function getPlayAuthorizationUrl() {
  return makeRequest(`/v2/play-console/authorization`)
}

export function completePlayAuthorization({ code, state }) {
  return makeRequest(`/v2/play-console/authorization/callback?${paramsToQuery({
    code,
    state,
  })}`, {
    method: 'GET',
  })
}
